import React, { useState, useRef, useEffect } from "react";

export const Tooltip = ({ content, listItems, children }) => {
	const [show, setShow] = useState(false);
	const [position, setPosition] = useState({ top: 0, left: 0 });
	const triggerRef = useRef(null);

	useEffect(() => {
		if (show && triggerRef.current) {
			const rect = triggerRef.current.getBoundingClientRect();
			setPosition({
				top: rect.top - 8,
				left: rect.left + rect.width / 2,
			});
		}
	}, [show]);

	if (!content) {
		return children;
	}

	return (
		<div
			ref={triggerRef}
			className="relative inline-flex"
			onMouseEnter={() => setShow(true)}
			onMouseLeave={() => setShow(false)}
			onFocus={() => setShow(true)}
			onBlur={() => setShow(false)}
		>
			{show && (
				<div 
					className="fixed -translate-x-1/2 -translate-y-full px-2 py-1 bg-dracula-selection text-dracula-foreground dark:bg-dracula-background dark:text-dracula-foreground text-xs rounded whitespace-nowrap shadow-md pointer-events-none"
					style={{ top: `${position.top}px`, left: `${position.left}px`, zIndex: 9999 }}
				>
					{content}
					{listItems && listItems.map((item) => <li key={item}>{item}</li>)}
				</div>
			)}
			{children}
		</div>
	);
};
